/* eslint import/namespace: ['error', { allowComputed: true }] */
import * as opentracing from 'opentracing';

import * as tracers from '../tracers';

import tracingWrapper from './open-tracing-wrapper';
import subscribeEvents from './pub-sub-subscribe';

/**
 * Wait for pubsub object.
 *
 * @param tries
 */
function waitForPubSub(tries = 0) {
  if (tries === 20) {
    console.warn('[OpenTracing] Failed to find pubsub object.');
    return;
  }

  const pubsub = window.sdc && window.sdc.pubSub;

  if (pubsub) {
    subscribeEvents(pubsub);
  }

  setTimeout(() => waitForPubSub(tries + 1), 100);
}

/**
 * Bootstrap tracer.
 *
 * @param config
 * @param javascriptOnlyMode
 */
function bootstrap(config, javascriptOnlyMode = true) {
  if (!config) {
    console.warn('[OpenTracing] No OpenTracing config found!');
    return;
  }

  if (config.javascriptOnlyMode !== javascriptOnlyMode) {
    return;
  }

  const provider = config.provider;
  if (!provider || !tracers[provider]) {
    console.error(`No tracer found for provider ${provider}`);
    return;
  }

  const tracer = tracers[provider];
  const globalTracer = tracer(config);

  opentracing.initGlobalTracer(globalTracer);

  window.sdc = window.sdc || {};
  window.sdc.openTracing = tracingWrapper(opentracing.globalTracer());

  waitForPubSub();
}

bootstrap(window.OPEN_TRACING_CONFIG, true);

export default function(rootElement) {
  if (!rootElement) {
    return
  }

  bootstrap(window.OPEN_TRACING_CONFIG, false);
}
